import {
  BufferGeometry,
  LineBasicMaterial,
  LineLoop,
  Shape,
  Vector3,
  type Object3D,
} from 'three';
import { CARD_HEIGHT, CARD_WIDTH } from './card-mesh.js';

const CORNER_RADIUS = 0.06;

function roundedRect(w: number, h: number, r: number): Shape {
  const s = new Shape();
  const x = -w / 2;
  const y = -h / 2;
  s.moveTo(x + r, y);
  s.lineTo(x + w - r, y);
  s.quadraticCurveTo(x + w, y, x + w, y + r);
  s.lineTo(x + w, y + h - r);
  s.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  s.lineTo(x + r, y + h);
  s.quadraticCurveTo(x, y + h, x, y + h - r);
  s.lineTo(x, y + r);
  s.quadraticCurveTo(x, y, x + r, y);
  return s;
}

export function createSlotMarker(): Object3D {
  const shape = roundedRect(CARD_WIDTH, CARD_HEIGHT, CORNER_RADIUS);
  const pts = shape.getPoints(40).map((p) => new Vector3(p.x, 0, -p.y));
  const geometry = new BufferGeometry().setFromPoints(pts);
  const material = new LineBasicMaterial({
    color: 0xc8a96a,
    transparent: true,
    opacity: 0.22,
  });
  const loop = new LineLoop(geometry, material);
  loop.position.y = 0.001;
  return loop;
}
